export default __webpack_public_path__ + "static/media/currently_running.35114507.svg";